export const BALANCE_STATUS = {
  opened: {
    textClass: 'text-warning',
    description: 'Este balanço ainda pode sofrer alterações nos valores',
  },
  paid: {
    textClass: 'text-success',
    description:
      'Este balanço já fechou e você recebeu o pagamento do valor total',
  },
  error: {
    textClass: 'text-error',
    description:
      'Algo deu errado ao tentar efetuar o pagamento, tentaremos novamente em breve',
  },
  closed: {
    textClass: 'text-warning',
    description: 'Este balanço está fechado, em breve será feito o pagamento',
  },
}

export const SUBSCRIPTION_STATUS = {
  active: 'Ativa',
  canceled: 'Cancelada',
  expired: 'Expirada',
}

export const IMPORT_CSV_STATUS = {
  pending: {
    textClass: 'text-warning',
    description: 'Pendente',
  },
  running: {
    textClass: 'text-success pulse',
    description: 'Executando',
  },
  done: {
    textClass: 'text-success',
    description: 'Pronto',
  },
  error: {
    textClass: 'text-error',
    description: 'Erro',
  },
}
